import React from 'react';
import { LightbulbIcon, CheckIcon } from 'lucide-react';
import { Card, CardContent } from './ui/Card';
import { FUNNEL_TYPES, TEMPLATES } from '../lib/data';
const OUTCOMES = ['Grow your audience', 'Generate Leads', 'Host a webinar', 'Sell a digital product', 'Sell a physical product', 'Sell a service'];
// Dynamically extract categories from TEMPLATES to ensure they always match
const CATEGORIES = Array.from(new Set(TEMPLATES.map(t => t.category))).sort();
interface FilterSidebarProps {
  selectedOutcome: string | null;
  onSelectOutcome: (outcome: string) => void;
  selectedFunnelTypes: string[];
  onToggleFunnelType: (id: string) => void;
  selectedCategories: string[];
  onToggleCategory: (category: string) => void;
}
export function FilterSidebar({
  selectedOutcome,
  onSelectOutcome,
  selectedFunnelTypes,
  onToggleFunnelType,
  selectedCategories,
  onToggleCategory
}: FilterSidebarProps) {
  return <div className="w-full md:w-64 flex-shrink-0 space-y-5" data-id="element-1">
      <Card className="border-border shadow-sm" data-id="element-2">
        <CardContent className="p-5 space-y-6" data-id="element-3">
          {/* Outcome */}
          <div data-id="element-4">
            <h3 className="font-semibold text-foreground mb-3 text-sm" data-id="element-5">
              Outcome
            </h3>
            <div className="space-y-2.5" data-id="element-6">
              {OUTCOMES.map(outcome => {
              const isChecked = selectedOutcome === outcome;
              return <label key={outcome} className="flex items-center gap-2.5 cursor-pointer group" onClick={() => onSelectOutcome(outcome)} data-id="element-7">
                    <div className={`w-4 h-4 flex-shrink-0 rounded-full border flex items-center justify-center transition-colors ${isChecked ? 'bg-primary border-primary' : 'border-input group-hover:border-primary/50'}`} data-id="element-8">
                      {isChecked && <div className="w-2 h-2 rounded-full bg-primary-foreground" data-id="element-9" />}
                    </div>
                    <span className={`text-sm transition-colors whitespace-nowrap ${isChecked ? 'text-foreground font-medium' : 'text-muted-foreground group-hover:text-foreground'}`} data-id="element-10">
                      {outcome}
                    </span>
                  </label>;
            })}
            </div>
          </div>

          {/* Funnel Type */}
          <div data-id="element-11">
            <h3 className="font-semibold text-foreground mb-3 text-sm" data-id="element-12">
              Funnel Type
            </h3>
            <div className="space-y-2.5" data-id="element-13">
              {FUNNEL_TYPES.map(type => {
              const isChecked = selectedFunnelTypes.includes(type.id);
              return <label key={type.id} className="flex items-center gap-2.5 cursor-pointer group" onClick={() => onToggleFunnelType(type.id)} data-id="element-14">
                    <div className={`w-4 h-4 flex-shrink-0 rounded border flex items-center justify-center transition-colors ${isChecked ? 'bg-primary border-primary' : 'border-input group-hover:border-primary/50'}`} data-id="element-15">
                      {isChecked && <CheckIcon className="w-3 h-3 text-primary-foreground" data-id="element-16" />}
                    </div>
                    <span className={`text-sm transition-colors whitespace-nowrap ${isChecked ? 'text-foreground font-medium' : 'text-muted-foreground group-hover:text-foreground'}`} data-id="element-17">
                      {type.name}
                    </span>
                  </label>;
            })}
            </div>
          </div>

          {/* Category */}
          <div data-id="element-18">
            <h3 className="font-semibold text-foreground mb-3 text-sm" data-id="element-19">
              Category
            </h3>
            <div className="space-y-2.5" data-id="element-20">
              {CATEGORIES.map(category => {
              const isChecked = selectedCategories.includes(category);
              return <label key={category} className="flex items-center gap-2.5 cursor-pointer group" onClick={() => onToggleCategory(category)} data-id="element-21">
                    <div className={`w-4 h-4 flex-shrink-0 rounded border flex items-center justify-center transition-colors ${isChecked ? 'bg-primary border-primary' : 'border-input group-hover:border-primary/50'}`} data-id="element-22">
                      {isChecked && <CheckIcon className="w-3 h-3 text-primary-foreground" data-id="element-23" />}
                    </div>
                    <span className={`text-sm transition-colors whitespace-nowrap ${isChecked ? 'text-foreground font-medium' : 'text-muted-foreground group-hover:text-foreground'}`} data-id="element-24">
                      {category}
                    </span>
                  </label>;
            })}
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Quick Tips Section */}
      <Card className="bg-blue-50 border-blue-100 shadow-none" data-id="element-25">
        <CardContent className="p-4 space-y-2" data-id="element-26">
          <h3 className="text-sm font-semibold flex items-center gap-2 text-blue-800" data-id="element-27">
            <LightbulbIcon className="w-4 h-4 text-blue-600" data-id="element-28" />
            Quick Tip
          </h3>
          <p className="text-xs text-blue-700 leading-relaxed" data-id="element-29">
            Not sure where to start? Click a card above to learn about each
            funnel type, then use the filters here to find the right template.
          </p>
        </CardContent>
      </Card>
    </div>;
}